import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../components/Header/Loading';
import auth from '../firebase.init';
// import useAdmin from '../Hooks/useAdmin';

const RequireAdmin = ({children}) => {
    const [user, loading] = useAuthState(auth);

    // const [admin, adminLoading] = useAdmin(user)
    
    const location = useLocation()

    if(loading){
        return <Loading/>
    }
    
    if(!user){
        return <Navigate to='/login' state={{from: location}} replace></Navigate>
    }
    
    return children
};

export default RequireAdmin;